import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../slice/authSlice';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isLoading } = useSelector((state) => state.auth);
    const [error, setError] = useState(null);    

    const handleSubmit = (e) => {
        e.preventDefault();
        setError(null);
        dispatch(loginUser({ email, password }))
        .unwrap() 
        .then((response) => {        
            if(response.success){
                localStorage.setItem('authToken', response.token);
                localStorage.setItem('userEmail', email); // simpan email juga
                localStorage.setItem('kodecabang', response.kodecabang);
                localStorage.setItem('grup', response.grup);
                localStorage.setItem('namacabang', response.namacabang);
                Swal.fire("Success", response.message, 'success');
                navigate('/'); 
            }else{
                setError(response.message)
            }
        })
        .catch((err) => {
            setError(err)
            console.error('Login failed:', err);
        });
    };

    return (
        <div className='row' style={{ height: '100vh' }}>
            <div className='col-md-8'></div>
            <div className='col-md-4' style={{ backgroundColor: '#28333f' }}>
                <div className="row align-items-center" style={{ height: '100vh' }}>
                    <div className='col-12'>
                        <div className="row justify-content-center">
                            <div className="col-8">
                                <div className='d-flex align-items-center mt-3 mb-2'>
                                    <i className="bi bi-person-fill-lock mx-2 bg-white rounded-circle px-1" style={{ fontSize: "20px", color: "#16a085" }}></i>
                                    <p className='m-0 p-0' style={{ color: '#16a085' }}>Welcome To</p>               
                                </div>
                                <h3 className='title text-white'>TOWASS AUTOMATION</h3>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-8">
                                {error && <div className="alert alert-danger" data-bs-theme="dark" role="alert">
                                    <div>{error}</div>
                                </div>}
                            </div>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="row justify-content-center">
                                <div className="col-8">
                                    <div className='form-group my-3'>
                                        <label className='text-white'>Email</label>
                                        <input type='text' style={{ backgroundColor: '#28333f', color: 'white', height: "45px", border: error && error.email ? "red 2px solid" : "#15191e 2px solid", borderRadius: "10px" }} placeholder='Email' onChange={(e) => setEmail(e.target.value)} value={email} className='form-control'></input>
                                        {error && error.email && error.email.map((errEmail, index) => (
                                            <div className="text-danger" key={index}>{errEmail}</div>
                                        ))}
                                    </div>
                                    <div className='form-group my-3'>
                                        <label className='text-white'>Password</label>
                                        <input type='password' style={{ backgroundColor: '#28333f', color: 'white', height: "45px", border: error && error.password ? "red 2px solid" : "#15191e 2px solid", borderRadius: "10px" }} placeholder='Password' onChange={(e) => setPassword(e.target.value)} value={password} className='form-control'></input>
                                        {error && error.password && error.password.map((errPassword, index) => (
                                            <div className="text-danger" key={index}>{errPassword}</div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-8">
                                    <button type='submit' className='btn btn-light mt-3 w-100 py-2 fw-semibold fs-5' disabled={isLoading}>{isLoading ? 'Loading...' : 'LOGIN'}</button>  
                                </div>
                            </div>
                        </form>     
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;